import { render, staticRenderFns } from "./enquiry.vue?vue&type=template&id=1950d96e&scoped=true&"
import script from "./enquiry.vue?vue&type=script&lang=js&"
export * from "./enquiry.vue?vue&type=script&lang=js&"
import style0 from "./feedback.css?vue&type=style&index=0&id=1950d96e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1950d96e",
  null
  
)

export default component.exports